import { render } from "./Event.vue?vue&type=template&id=777b74d4&scoped=true&ts=true"
import script from "./Event.vue?vue&type=script&lang=ts"
export * from "./Event.vue?vue&type=script&lang=ts"

import "./Event.vue?vue&type=style&index=0&id=777b74d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777b74d4"]])

export default __exports__